export default __webpack_public_path__ + "static/media/pagePhoto2.47eec3bc.png";